<template>
  <div id="globalTooltip"
    v-show="visible && !$store.state.drawingAnnotation"
    @mouseover="visible = true"
    @mouseout="visible = false">
    <p class="title">{{ tooltipData.name }}</p>
    <p class="desc">{{ tooltipData.text }}</p>
    <p class="desc">Tab order: {{ tooltipData.tabOrder }}</p>
  </div>
</template>

<script>
export default {
  name: 'global-tooltip',

  data () {
    return {
      visible: false,
      tooltipData: {}
    }
  },

  mounted () {
    let that = this
    this.$bus.on('showTooltip', function (fieldId) {
      const fieldIndex = that.$store.getters.templateFieldIndex(
        that.$store.state.currentTemplateName,
        fieldId,
        that.$store.state.fileCurrentPage
      )

      if (fieldIndex === undefined) return
      that.tooltipData = that.$store.getters.fieldTooltip(that.$store.state.fileCurrentPage, fieldIndex)
      that.visible = true
    })

    this.$bus.on('hideTooltip', function () {
      that.visible = false
    })
  },

  beforeDestroy () {
    this.$bus.$off('showTooltip')
    this.$bus.$off('hideTooltip')
  }
}
</script>

<style lang="scss" scoped>
  #globalTooltip {
    user-select: none;
    position: fixed;
    height: 200px;
    bottom: 2%;
    left: 25%;
    transform: translateX(-50%);
    // right: 0;
    margin: 0 auto;
    z-index: 101;
    width: 30%;
    padding: 5px 25px 0 25px;
    // color: #000;
    background-color: #CCC;
    // border-style: solid;
    // border-color: #333;
    // border-width: 3px 3px 0 3px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    overflow: hidden;

    p {
      margin: 0;
    }

    .title {
      font-size: 10pt;
      font-weight: bold;
    }

    .desc {
      margin: 0;
      font-size: 8.5pt;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/editor/main/GlobalTooltip.vue